import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CwtDirectiveView, isset } from '@cawita/core-front';
import { User } from '@shared/models';
import { Subscription } from 'rxjs';
import { LoggedUserStore } from './user.store';

export type LoggedUserContext = {
  $implicit: User;
}

@Directive({
  selector: '[cwtLoggedUser]'
})
export class LoggedUserDirective implements OnInit, OnDestroy {

  private _sub: Subscription;
  private _ctx: LoggedUserContext = { $implicit: null };
  private _view = new CwtDirectiveView(this.vcRef, this.tRef, this._ctx);

  constructor(
    private tRef: TemplateRef<LoggedUserContext>,
    private vcRef: ViewContainerRef,
    private userStore: LoggedUserStore
  ) { }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }

  ngOnInit(): void {
    this._sub = this.userStore.stableState$.subscribe({
      next: (state) => {
        this._ctx.$implicit = state.user;
        this._view.ensureState(isset(state.user));
      }
    });
  }

}
